<div class="row mt-5">
  <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
    <div class="card card_one">
      <div class="card-body">
        <div class="d-flex justify-content-between p-md-1">
          <div class="d-flex flex-row">
            <div>
              <div class="colum_records">
                <p>{{title_one}}</p>
                <div class="total" style="height: 10px;">
                  <p class="text-dark" style="margin-top: -20px;">{{numberone}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="align-self-center">
            <i class="fa-solid fa-calendar-check"
              style="color:#000; font-size:30px;margin-right: 20px;margin-top: -20px;"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
    <div class="card card_dos">
      <div class="card-body">
        <div class="d-flex justify-content-between p-md-1">
          <div class="d-flex flex-row">
            <div>
              <div class="colum_aprob">
                <p>{{title_dos}}</p>
                <div class="total" style="height: 10px;">
                  <p class="text-dark" style="margin-top: -20px;">{{numberdos}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="align-self-center">
            <i class="fa-regular fa-thumbs-up"
              style="color:#000; font-size:30px;margin-right: 20px;margin-top: -20px;"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
    <div class="card card_tres">
      <div class="card-body">
        <div class="d-flex justify-content-between p-md-1">
          <div class="d-flex flex-row">
            <div>
              <div class="colum_validate">
                <p>{{title_tres}}</p>
                <div class="total" style="height: 10px;">
                  <p class="text-dark" style="margin-top: -20px;">{{numbertres}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="align-self-center">
            <i class="fa-sharp fa-solid fa-check"
              style="color:#000; font-size:30px;margin-right: 20px;margin-top: -20px;"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
    <div class="card card_cuatro">
      <div class="card-body">
        <div class="d-flex justify-content-between p-md-1">
          <div class="d-flex flex-row">
            <div>
              <div class="colum_block">
                <p style="width: 100px;" class="main_text">{{title_cuatro}}</p>
                <div class="total" style="height: 10px;">
                  <p class="text-dark" style="margin-top: -20px;">{{numbercuatro}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="align-self-center">
            <i class="fa-regular fa-circle-xmark"
              style="color:#000; font-size:30px;margin-right: 20px;margin-top: -20px;"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="col-xxl-6 col-md-6 col-lg-6 col-sm-12 col-xs-12">
    <div class="card card_bar">
      <div class="card-header">
        Trámites SST
      </div>
      <div class="card-body">
        <div style="width: 600px;height: auto;" class="bar">
          <canvas id="myChart" height="275"></canvas>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xxl-6 col-md-6 col-lg-6 col-sm-12 col-xs-12">
    <div class="card card_bar">
      <div class="card-header">
        Licencias Emitidas
      </div>
      <div class="card-body">
        <div style="width: 552px;height: auto;" class="bar">
          <canvas id="myChartDount" height="220" style="width: 50% !important;"></canvas>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row mt-3">
  <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
    <div class="card card_table">
      <div class="card-header">
        Estado trámites
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table" aria-describedby="mydesc">
            <thead>
              <tr>
                <th scope="col">Id Estado</th>
                <th scope="col">Descripción</th>
                <th scope="col">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of totalArray let i= index">
                <td>{{item.id}}</td>
                <td>{{item.description}}</td>
                <td>{{item.amount}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
